<template>
  <div class="language-select">
    <div class="text">
      请选择你擅长的编程语言进行比赛，请注意<span class="color">一旦选择后将直接开始比赛，不可退出更改。</span>
    </div>
    <div class="options">
      <my_button value="Python" :inputStyle="buttonStyle" @click.native="next('python')"></my_button>
      <my_button value="C++" :inputStyle="buttonStyle" @click.native="next('cpp')"></my_button>
    </div>
  </div>
</template>

<script>
  import MyButton from '@/components/Button.vue';
export default {
  name: 'finalPlayLang',
  components: {
    my_button: MyButton,
  },
  data () {
    return {
      meetings: [
        '113882226',
        '246625933',
      ]
    }
  },
  computed: {
     buttonStyle() {
        return {
          'border-radius': '5px',
          'margin-top': '2vw',
          'width': '8em'
        }
      },
  },
  methods: {
    next (lang) {
      const data = new FormData()
      data.set('language', lang)
      this.$http.post('/api/final/classroom/join', data).then(res => {
        console.log("success")
        this.$emit("next", lang)
      })
    }
  }
}
</script>

<style scoped>
.language-select {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.numbers {
  display: flex;
  flex-direction: column;
}
.numbers > .number {
  margin-top: 10px;
  margin-bottom: 10px;
}
.options {
  display: flex;
  width: 800px;
  justify-content: space-around;
}

.text {
  margin-top: 20px;
}
.color {
  color: #fa5151;
}
</style>
